import { getDate } from "../../SHARED/helpers/get-date";
import { global } from ":shared/app";
import type { GET as Team } from "./teams";
const endpoints = {
  post: (user: string) => `scoring/${user}/create/`,
  put: (user: string, id: number) => `scoring/${user}/update/${String(id)}/`,
};

type ATeam = Team["returns"]["teams"][number];
export type POST_PUT = {
  props: { team: ATeam; scores: { [k: string]: number } };
  returns: ATeam;
};
export async function postOrPut(props: POST_PUT["props"]): Promise<POST_PUT["returns"]> {
  // return import("./scoring.mocks").then((res) => {
  //   return res.success;
  // });
  const team = props.team;
  const new_eval = team.scores == undefined;
  const user = getUserPath();
  return (
    new_eval
      ? global.api.postAuth(endpoints.post(user), { ...props.scores, team: team.id })
      : global.api.putAuth(endpoints.put(user, team.eval_id), props.scores)
  ).then((res) => {
    const res_team = res.data as ATeam;
    res_team.eval_time = getDate(res_team.eval_time);
    return Promise.resolve(res_team);
  });
}

function getUserPath() {
  const jwt = global.api.auth.token.decoded();
  if (jwt.user_key === "evaluator") {
    return "evaluation";
  }
  if (jwt.user_key === "judge") {
    return "judging";
  }
  if (jwt.user_key === "filterer") {
    return "filtration";
  }
  throw new Error("unknown user type for scoring api");
}
